import { useSdk } from '~/sdk';
import type { GetCountriesResponse } from '@vue-storefront/prestashop-api';

interface UseCountries {
  data: GetCountriesResponse['psdata']['countries'] | null;
  pending: boolean;
  error: any;
  groups: any;
}

export function useCountries() {
  const { locale } = useI18n();

  const state = useState<UseCountries>(() => ({
    data: [],
    pending: false,
    error: null,
    groups: {},
  }));
  async function fetchCountries() {
    state.value.pending = true;
    const { data, error } = await useAsyncData(() => useSdk().commerce.getCountries());
    useHandleError(error.value);
    
    // Handle the response structure properly
    const response = data.value;
    if (Array.isArray(response)) {
      // If response is an array, it's just countries
      state.value.data = response || [];
      state.value.groups = {};
    } else if (response && typeof response === 'object') {
      // If response is an object with countries and groups
      state.value.data = (response as any).countries || [];
      state.value.groups = (response as any).groups || {};
    } else {
      state.value.data = [];
      state.value.groups = {};
    }
    
    state.value.pending = false;
  }

  watch(locale, fetchCountries);

  return {
    ...toRefs(state.value),
    execute: fetchCountries,
  };
}
